import { render, staticRenderFns } from "./TestScreen.vue?vue&type=template&id=796ca942&"
import script from "./TestScreen.vue?vue&type=script&lang=js&"
export * from "./TestScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports